"use strict"

import { fetch as fetchPolyfill } from 'whatwg-fetch';

export function init() {
    isLoggedIn().then(loggedIn => {
        if (loggedIn) {
            document.body.classList.add('user-logged-in');
        } else {
            document.body.classList.add('user-logged-out');
        }
    }).catch(e => {
        console.error('Failed to get logged in status', e);
        document.body.classList.add('user-logged-out');
    });

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}

const localHosts = Object.freeze([
    'localhost',
    '127.0.0.1',
]);

async function isLoggedIn() {
    if (localHosts.includes(document.location.hostname)) {
        return true;
    }
    try {
        const sessionKey = await getSessionKey();
        if (!sessionKey) {
            return false;
        }

        const response = await fetchPolyfill(`${window.AppConfig.proxyDomain}/Web/Session/${sessionKey}`);
        const data = await response.json();

        return data.IsLoggedIn;
    } catch (error) {
        return false;
    }
}

async function getSessionKey() {
    return fetchPolyfill(`${window.AppConfig.tnewDomain}api/session/sessionkey/`, {
            credentials: 'include',
        })
        .then(r => r.json())
        .then(r => (r.encryptedSessionKey))
        .then(encryptedSessionKey => {
            return fetchPolyfill(`${window.AppConfig.proxyDomain}/decrypt`, {
                method: 'POST',
                body: JSON.stringify({ key: encryptedSessionKey }),
                headers: {
                    'Content-Type': 'application/json'
                },
            });
        })
        .then(r => r.json())
        .catch(e => {
            console.error('Failed to get TNEW Session Key', e);
            return false;
        });
}
